import { DATA_SOURCE, DATA_SOURCE_METRICS } from '@intelligence/_config/enumeration/dataSource';
import { ALINEA_CALIBRATION_METRICS } from '@intelligence/v3/pages/TopCharts/PCConsoleGames/AlineaAnalyticsCalibration/constants';
import { METRICLISTOPTIONSCOMBINE, METRICLISTOPTIONSMOBILE } from './config';

export type TrueDataMetricSource = 'databrain' | 'alinea';

interface ITrueDataMetricTextOptions {
  /** DataBrain 使用通用指标枚举；Alinea 使用 alinea_calibration 指标枚举。 */
  source?: TrueDataMetricSource;
  locale?: string;
  /** 页面层文案解析器；纯工具不直接依赖 React 国际化上下文。 */
  formatMessage?: IFormatMessage;
  emptyText?: string;
}

const normalizeTrueDataMetricName = (metricName: string): string => {
  return metricName.trim().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').toLocaleLowerCase();
};

/**
 * 真数弹窗两种接口返回不同的指标命名空间，但最终都输出同一列的展示文案。
 * 这里按来源选择既有指标枚举，避免在表格和下载配置中分别实现格式化。
 */
export const getTrueDataMetricText = (
  metricName?: string,
  options: ITrueDataMetricTextOptions = {},
): string => {
  const { source = 'databrain', locale, formatMessage, emptyText = '-' } = options;
  if (!metricName) {
    return emptyText;
  }

  if (source === 'alinea') {
    // Alinea history 返回 copies_sold 等短指标名；配置使用 alinea_calibration__ 命名空间。
    const metricKey = metricName.startsWith('alinea_calibration__')
      ? metricName
      : `alinea_calibration__${metricName}`;
    const metricConfig = ALINEA_CALIBRATION_METRICS.find((item) => item.value === metricKey);

    if (metricConfig) {
      return locale === 'zh-CN' ? metricConfig.labelCN : metricConfig.label;
    }

    return metricName;
  }

  const normalizedMetricName = normalizeTrueDataMetricName(metricName);
  const metricConfig = DATA_SOURCE_METRICS[metricName]
    || DATA_SOURCE[metricName]
    || Object.values(DATA_SOURCE_METRICS).find((item) => {
      return [item?.key, item?.value, item?.label].some((value) => {
        return normalizeTrueDataMetricName(String(value || '')) === normalizedMetricName;
      });
    });
  if (metricConfig?.labelKey && formatMessage) {
    return formatMessage({ id: metricConfig.labelKey });
  }
  if (metricConfig?.label) {
    return metricConfig.label;
  }

  const metricOption = [...METRICLISTOPTIONSCOMBINE, ...METRICLISTOPTIONSMOBILE].find(
    (option) => normalizeTrueDataMetricName(option.value) === normalizedMetricName,
  );

  return metricOption?.text || metricName;
};
